<template>
  <div
    class="ppt-edit-notify horizontal layout center"
    v-if="powerPointSlideId || activePresentationPowerpointId"
    v-tooltip="'This message will disappear when you present'"
  >
    <i class="fas fa-check mr-3"></i>
    <div v-if="activePresentationPowerpointId">
      Presentation selected for PowerPoint
    </div>
    <div v-else>
      Slide {{ indexActiveSlide }} selected for PowerPoint
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      powerPointSlideId: (state) => state.powerPointSlideId,
      activePresentationPowerpointId: (state) => state.activePresentationPowerpointId,
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
    }),
    indexActiveSlide() {
      return this.presentation.slides.findIndex((item) => item.id === this.slideActive.id) + 1
    },
  },

  destroy() {
  },
}
</script>

<style lang="scss" scoped>
.ppt-edit-notify {
  position: absolute;
  bottom: 70px;
  left: 38px;
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid #ddd;
  border-radius: 8px;
  z-index: 100;
  padding: 10px 16px;
  height: 52px;
  color: #313131;
  .fa-check {
    color: #33C073;
  }
}
</style>
